import type { Ref } from 'react';
import styled from 'styled-components';

const StyledVideo = styled.video`
  display: none;
  width: inherit;
  object-fit: inherit;
  aspect-ratio: inherit;
  height: inherit;
`;

type Props = {
  av1Src: string;
  hevcSrc: string;
  customDataAttribute?: string;
  ref?: Ref<HTMLVideoElement>;
};
export const InvisibleVideo = ({
  av1Src,
  hevcSrc,
  customDataAttribute,
  ref,
}: Props) => {
  return (
    <StyledVideo
      crossOrigin="anonymous"
      ref={ref}
      muted
      playsInline
      data-invisible-video={customDataAttribute}
    >
      <source
        src={av1Src}
        type="video/mp4; codecs=av01.0.08M.08.0.110.01.01.01.1"
      />
      <source src={hevcSrc} type="video/mp4; codecs=hvc1.1.6.H120.b0" />
    </StyledVideo>
  );
};
